'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'palette';
var width = 512;
var height = 512;
var aliases = [127912];
var unicode = 'f53f';
var svgPathData = 'M152 255.1C152 269.3 141.3 279.1 128 279.1C114.7 279.1 104 269.3 104 255.1C104 242.7 114.7 231.1 128 231.1C141.3 231.1 152 242.7 152 255.1zM136 159.1C136 146.7 146.7 135.1 160 135.1C173.3 135.1 184 146.7 184 159.1C184 173.3 173.3 183.1 160 183.1C146.7 183.1 136 173.3 136 159.1zM280 127.1C280 141.3 269.3 151.1 256 151.1C242.7 151.1 232 141.3 232 127.1C232 114.7 242.7 103.1 256 103.1C269.3 103.1 280 114.7 280 127.1zM328 159.1C328 146.7 338.7 135.1 352 135.1C365.3 135.1 376 146.7 376 159.1C376 173.3 365.3 183.1 352 183.1C338.7 183.1 328 173.3 328 159.1zM441.9 319.1H344C317.5 319.1 296 341.5 296 368C296 371.4 296.4 374.7 297 377.9C299.2 388.1 303.5 397.1 307.9 407.8C313.9 421.6 320 435.3 320 449.8C320 481.7 298.4 510.5 266.6 511.8C263.1 511.9 259.5 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 256.9 511.1 257.8 511.1 258.7C511.6 295.2 478.4 320 441.9 320V319.1zM479.1 258.3C479.1 257.6 480 256.8 480 255.1C480 132.3 379.7 31.1 256 31.1C132.3 31.1 32 132.3 32 255.1C32 379.7 132.3 480 256 480C259.1 480 262.2 479.9 265.3 479.8C275.7 479.4 288 469.1 288 449.8C288 444.6 286.1 438 281.1 426.4C280.4 424.9 279.7 423.3 278.1 421.6C274.6 411.9 268.6 398.3 265.7 384.6C264.6 379.2 264 373.6 264 368C264 323.8 299.8 288 344 288H441.9C466.2 288 479.8 272.4 479.1 258.3V258.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPalette = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;